import React, { useRef } from 'react'
import { generatePath, Link } from 'react-router-dom'
import TableComponent, { TableComponentType } from 'UI/Table'
import { IColumn } from 'typescript/interfaces/tableUi'
import { useTableComponentStyle } from 'UI/Table/style'
import { convertDate, convertEmptyField, convertToPriceFormat } from 'utils/formatters'
import { ITodaysPaymentReportListItem } from 'typescript/interfaces/todaysPaymentReport'
import { DEAL_INFO_URL } from 'constants/routes'
import cn from 'classnames'

export const TableTodaysPaymentReport = TableComponent as TableComponentType<ITodaysPaymentReportListItem>

export const useTodaysPaymentReport = () => {
  const classes = useTableComponentStyle({})
  const columns = useRef<Array<IColumn<ITodaysPaymentReportListItem>>>([
    {
      label: 'ID #',
      field: 'id',
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: data => convertEmptyField(data.id),
    },
    {
      label: 'Deal ID',
      field: 'dealId',
      bodyCellClassName: classes.secondaryBodyCell,
      sorting: true,
      render: data =>
        data.dealId ? (
          <Link to={generatePath(DEAL_INFO_URL, { id: data.dealId.toString() })}>{convertEmptyField(data.dealId)}</Link>
        ) : (
          convertEmptyField(data.dealId)
        ),
    },
    {
      label: 'Deal Name',
      sorting: true,
      field: 'dealName',
      bodyCellClassName: classes.accentCell,
      render: data => convertEmptyField(data.dealName),
    },
    {
      label: 'Trs Type',
      sorting: true,
      field: 'category',
      bodyCellClassName: classes.accentCell,
      render: data => convertEmptyField(data.category),
    },
    {
      label: 'Status',
      sorting: true,
      field: 'status',
      bodyCellClassName: classes.accentCell,
      render: data => convertEmptyField(data.status),
    },
    {
      label: 'Comments',
      sorting: true,
      field: 'comments',
      bodyCellClassName: cn(classes.secondaryBodyCell, classes.maxTextCellWidth),
      render: data => convertEmptyField(data.comments),
    },
    {
      label: 'Payment Scheduled',
      field: 'scheduledDate',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data => convertDate(data.scheduledDate),
    },
    {
      label: 'Payment Date',
      field: 'paymentDate',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data => convertDate(data.paymentDate),
    },
    {
      label: 'Transaction Value',
      sorting: true,
      field: 'amount',
      bodyCellClassName: classes.secondaryBodyCell,
      render: data => (data.category.startsWith('PageTo') ? `(${convertToPriceFormat(data.amount)})` : convertToPriceFormat(data.amount)),
    }
  ])

  return {
    columns: columns.current,
  }
}
